import dynamic from 'next/dynamic';
import settings from '@/settings';
import { WebsiteSchema } from '@/components/homepage/WebsiteSchema';
import { getShortenCountryName } from '@/lib/use-origin-country';

const FrTermsOfSale = dynamic(
  () => import('@/components/policies/terms-of-sale/FR'),
);

const DeTermsOfSale = dynamic(
  () => import('@/components/policies/terms-of-sale/DE'),
);

const AtTermsOfSale = dynamic(
  () => import('@/components/policies/terms-of-sale/AT'),
);

const EsTermsOfSale = dynamic(
  () => import('@/components/policies/terms-of-sale/ES'),
);

const ItTermsOfSale = dynamic(
  () => import('@/components/policies/terms-of-sale/IT'),
);

const SeTermsOfSale = dynamic(
  () => import('@/components/policies/terms-of-sale/SE'),
);

const IeTermsOfSale = dynamic(
  () => import('@/components/policies/terms-of-sale/IE'),
);

const TermsOfSale = () => {
  // Exclusive to reebelo-fr (Conditions Générales de Vente), reebelo-de
  // (Allgemeine Verkaufsbedingungen), reebelo-es (Condiciones Generales
  // de Venta), reebelo-it (Condizioni Generali di Vendita), and reebelo-se
  // (Allmänna köpvillkor), reebelo-ie (General Terms and Conditions of Sale) and
  // reebelo-at (Allgemeine Verkaufsbedingungen).
  if (settings.store === 'reebelo-de') {
    return (
      <>
        <WebsiteSchema
          title={`Allgemeine Verkaufsbedingungen - Reebelo ${getShortenCountryName()}`}
          description={`Lesen Sie die Allgemeinen Verkaufsbedingungen von Reebelo ${settings.country}, dem führenden Marktplatz für generalüberholte Technik.`}
        />
        <DeTermsOfSale />
      </>
    );
  }

  if (settings.store === 'reebelo-at') {
    return (
      <>
        <WebsiteSchema
          title={`Allgemeine Verkaufsbedingungen - Reebelo ${getShortenCountryName()}`}
          description={`Lesen Sie die Allgemeinen Verkaufsbedingungen von Reebelo ${settings.country}, dem führenden Marktplatz für generalüberholte Technik.`}
        />
        <AtTermsOfSale />
      </>
    );
  }

  if (settings.store === 'reebelo-es') {
    return (
      <>
        <WebsiteSchema
          title={`Condiciones Generales de Venta - Reebelo ${getShortenCountryName()}`}
          description={`Consulte las Condiciones Generales de Venta de Reebelo ${settings.country}, el marketplace de referencia para la tecnología reacondicionada y sostenible.`}
        />
        <EsTermsOfSale />
      </>
    );
  }

  if (settings.store === 'reebelo-it') {
    return (
      <>
        <WebsiteSchema
          title={`Condizioni Generali di Vendita - Reebelo ${getShortenCountryName()}`}
          description={`Consulta le Condizioni Generali di Vendita di Reebelo ${settings.country}, il marketplace di riferimento per la tecnologia ricondizionata e sostenibile.`}
        />
        <ItTermsOfSale />
      </>
    );
  }

  if (settings.store === 'reebelo-se') {
    return (
      <>
        <WebsiteSchema
          title={`Allmänna köpvillkor - Reebelo ${getShortenCountryName()}`}
          description={`Läs de allmänna köpvillkoren för köp av renoverad teknik via Reebelo ${getShortenCountryName()}.`}
        />
        <SeTermsOfSale />
      </>
    );
  }

  if (settings.store === 'reebelo-ie') {
    return (
      <>
        <WebsiteSchema
          title={`General Terms and Conditions of Sale - Reebelo ${getShortenCountryName()}`}
          description={`Read the General Terms and Conditions of Sale of Reebelo ${settings.country}, the marketplace for refurbished and sustainable tech.`}
        />
        <IeTermsOfSale />
      </>
    );
  }

  if (settings.store !== 'reebelo-fr') {
    return null;
  }

  return (
    <>
      <WebsiteSchema
        title={`Conditions Générales de Vente - Reebelo ${getShortenCountryName()}`}
        description={`Consultez les Conditions Générales de Vente de Reebelo ${settings.country}, la marketplace de référence pour la tech durable et reconditionnée.`}
      />
      <FrTermsOfSale />
    </>
  );
};

export default TermsOfSale;
